<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 v-if="client && client.key && site && site.key" class="p-d-flex p-ai-baseline">
                    <router-link icon="pi pi-angle-left" class="p-button p-button-icon p-mr-4" v-if="client && client.key"
                        :to="{ name: 'site', params: { client_id: client.key, id: site.key } }">
                        <i class="pi pi-angle-left"></i>
                        Back
                    </router-link>
                    <span>
                        <router-link :to="{ name: 'sites', params: { id: client.key } }">{{ client.name }}</router-link> /
                        <router-link :to="{ name: 'site', params: { client_id: client.key, id: site.key } }">{{ site.name
                        }}</router-link> /
                        Documents
                    </span>
                </h4>

                <TabView>
                    <TabPanel header="Documents">
                        <Toast />
                        <FileUpload name="template_docs[]" :customUpload="true" @uploader="startUpload" :multiple="true"
                            :maxFileSize="25000000" ref="uploader" class="p-mb-3" />
                        <div class="p-fileupload-files" v-if="siteDocuments">
                            <div class="p-fileupload-row p-mb-1" v-for="file of siteDocuments"
                                :key="file.name + file.type + file.size">
                                <div v-if="file.type == 'image/jpeg'">
                                    <img role="presentation" :alt="file.name" :src="file.src" width="44"
                                        class="p-d-block" />
                                </div>
                                <div v-else><i class="pi pi-file-pdf p-tree p-d-inline-block"></i></div>
                                <div>{{ file.name }}</div>
                                <div class="p-d-flex p-jc-end">
                                    <a :href="file.src" target="_blank" class="p-button p-button-icon-only p-mr-2"><i
                                            class="pi pi-download p-button-icon"></i></a>
                                    <Button type="button" icon="pi pi-trash" @click="openModal(file, true)" />
                                </div>
                            </div>
                        </div>
                        <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{ width: '350px' }"
                            :modal="true">
                            <div class="confirmation-content">
                                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
                                <span>Are you sure you want to proceed?</span>
                            </div>
                            <template #footer>
                                <Button label="No" icon="pi pi-times" @click="openModal(null, false)"
                                    class="p-button-text" />
                                <Button label="Yes" icon="pi pi-check"
                                    @click="removeUpload(selectedDocument), openModal(null, false)" class="p-button-text"
                                    autofocus />
                            </template>
                        </Dialog>
                    </TabPanel>
                </TabView>
            </div>
        </div>
</div>
</template>

<script>
import { db, storage } from '@/firebase';
import Vue2Filters from 'vue2-filters';
import moment from 'moment';

export default {
    props: ['user'],
    mixins: [Vue2Filters.mixin],
    data() {
        return {
            client: {},
            site: {},
            siteDocuments: [],
            selectedDocument: {},
            displayConfirmation: false,
        }
    },
    firestore() {
        return {
            siteDocuments: db.collection('site_docs').where('client_id', '==', this.$route.params.client_id).where('site_id', '==', this.$route.params.id),
            documents: db.collection('site_docs'),
            site: db.collection('sites').doc(this.$route.params.id),
            client: db.collection('clients').doc(this.$route.params.client_id),
        }
    },
    methods: {
        openModal(file, display) {
            if(display) {
                this.selectedDocument = file;
                this.displayConfirmation = true;
            } else {
                this.selectedDocument = '';
                this.displayConfirmation = false;
            }
        },
        format_date(value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY @ hh:mma')
            }
        },
        startUpload(event) {
            event.files.forEach(file => {
                let uniqueName = Date.now() + '_' + file.name;
                this.$refs.uploader.progress = 0;
                this.convertToBase64(file, base64String => {
                    const storageRef = storage.ref('site/docs/' + this.site.key + '/' + uniqueName).putString(base64String, 'data_url');

                    storageRef.on(`state_changed`, snapshot => {
                        this.$refs.uploader.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    }, error => {
                        /* eslint-disable no-console */
                        console.log(error.message)
                        /* eslint-enable no-console */
                    }, () => {
                        this.$refs.uploader.progress = 100;
                        storageRef.snapshot.ref.getDownloadURL().then((url) => {
                            const doc = {
                                src: url,
                                type: file.type,
                                name: file.name,
                                uniqueName: uniqueName,
                                site_id: this.site.key,
                                client_id: this.$route.params.client_id,
                            }
                            this.$firestore.documents.add(doc);
                        });
                    });
                });
            });
            db.collection('logs').add({
                activity: 'File(s) uploaded',
                timestamp: new Date(),
                user: this.user.email,
                client_id: this.user.client.key,
                site: this.site.name
            }).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'File(s) uploaded', life: 3000 });
            });
            this.$refs.uploader.clear();
        },
        removeUpload(file) {
            const storageRef = storage.ref();
            const docRef = storageRef.child('site/docs/' + this.site.key + '/' + file.uniqueName);
            // console.log(docRef);

            docRef.delete().then(() => {
                // File deleted successfully
                this.$firestore.documents.doc(file.key).delete().then(() => {
                    db.collection('logs').add({
                        activity: 'File deleted',
                        timestamp: new Date(),
                        user: this.user.email,
                        client_id: this.user.client.key,
                        site: this.site.name
                    }).then(() => {
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'File deleted', life: 3000 });
                    });
                });
            }).catch(() => {
                // Uh-oh, an error occurred!
            });
        },
        convertToBase64(file, cb) {
            // FileReader function for read the file.
            var fileReader = new FileReader();
            var base64;
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                cb(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        }
    }
}
</script>

<style scoped lang="scss">
.p-datatable-row-expansion {
    td {
        padding: 0;
    }
}</style>
